import ArrowSVG from '@/svg/icons/arrow.svg';
import SlackSVG from '@/svg/icons/slack.svg';

export default function SlackBanner() {
  return (
    <div className="relative overflow-hidden rounded-lg bg-white shadow-image transition-all duration-300 ease-in-out hover:shadow-card-hover">
      <a
        href="https://slack.graphcms.com"
        target="_blank"
        rel="noopener noreferrer"
        className="block h-full w-full px-4 pb-9 pt-12 md:px-9 md:pt-16"
      >
        <h3 className="relative z-10 mb-6 text-xl font-bold leading-tight text-haiti md:pr-6 md:text-[38px]">
          Join our engaged{` `}
          <b className="block font-bold text-cornflower md:inline">
            Slack community
          </b>
        </h3>
        <p className="text-sm leading-normal text-light-haiti md:text-xl">
          Connect with an engaged community to get your questions answered and
          learn about new opportunities in the GraphQL space.
        </p>

        <p className="mt-6 flex items-center text-sm font-medium text-cornflower md:mt-10 md:text-base">
          <span>Join Slack Channel</span>
          <ArrowSVG className="ml-2 h-5 w-5 rotate-180 transform fill-current" />
        </p>

        <SlackSVG className="absolute top-0 right-0 z-0 -mt-2 -mr-2 h-20 w-20 text-catskill-white lg:h-32 lg:w-32" />
      </a>
    </div>
  );
}
